import React from 'react';

const AuthSuccess = () => {
    React.useEffect(() => {
        setTimeout(() => window.close(),1000);
    })

    return(<><h1>Thankyou</h1></>)
}

export default AuthSuccess;